import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useWallet } from '@solana/wallet-adapter-react';
import { BoomWordmark } from './premium/Logo';
import BoomConnectButton from './premium/BoomConnectButton';
import NotificationsBell from './premium/NotificationsBell';

const NAV = [
  { to: '/', label: 'Dashboard' },
  { to: '/portfolio', label: 'My Profile' },
  { to: '/leaderboard', label: 'Leaderboard' },
  { to: '/jackpot', label: 'Monthly Jackpot' },
  { to: '/groups', label: 'Communities' },
  { to: '/docs', label: 'Docs' },
];

const TREASURY_ADDRESS = 'FaDBjsBmzbGAMYUPKacNbm53Fe4ZoEfJMZVhuU4YHR8J';

const TopBar = React.memo(function TopBar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const wallet = useWallet();
  const isAdmin = wallet?.publicKey?.toBase58?.() === TREASURY_ADDRESS;
  const menuRef = useRef(null);

  const isActive = (to) => location.pathname === to;

  // Close dropdown when route changes (e.g. user picks a link)
  useEffect(() => { setMenuOpen(false); }, [location.pathname]);

  // Click-outside + Esc to close. Anchored dropdown lives in the nav,
  // so a click anywhere else in the page closes it.
  useEffect(() => {
    if (!menuOpen) return;
    const onClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    const onKey = (e) => { if (e.key === 'Escape') setMenuOpen(false); };
    document.addEventListener('mousedown', onClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onClick);
      document.removeEventListener('keydown', onKey);
    };
  }, [menuOpen]);

  return (
    <nav className="pm-nav">
      <div className="pm-nav__left">
        <div className="pm-nav__brand" onClick={() => navigate('/')} role="button" tabIndex={0}>
          <BoomWordmark size={22} />
        </div>
        <NotificationsBell />
      </div>

      <div className="pm-nav__right">
        <Link to="/deploy-token" className="pm-launch-btn">
          Launch
        </Link>

        <div className="pm-nav__menu" ref={menuRef}>
          <button
            type="button"
            className={`pm-nav__menu-trigger${menuOpen ? ' is-open' : ''}`}
            onClick={() => setMenuOpen((v) => !v)}
            aria-haspopup="menu"
            aria-expanded={menuOpen}
            aria-label="Menu"
          >
            <span className="pm-nav__menu-bars" aria-hidden="true">
              <span /><span /><span />
            </span>
            <span className="pm-nav__menu-label">Menu</span>
          </button>

          {menuOpen && (
            <div className="pm-nav__menu-pop" role="menu">
              {NAV.map((n) => (
                <Link
                  key={n.to}
                  to={n.to}
                  role="menuitem"
                  className={`pm-nav__menu-item${isActive(n.to) ? ' is-active' : ''}`}
                  onClick={() => setMenuOpen(false)}
                >
                  {n.label}
                </Link>
              ))}
              {isAdmin && (
                <Link
                  to="/slurp-ops"
                  role="menuitem"
                  className={`pm-nav__menu-item pm-nav__menu-item--admin${isActive('/slurp-ops') ? ' is-active' : ''}`}
                  onClick={() => setMenuOpen(false)}
                >
                  Admin
                </Link>
              )}
            </div>
          )}
        </div>

        <BoomConnectButton />
      </div>
    </nav>
  );
});

export default TopBar;
